import { createContext, useContext } from 'react';
import { useQuery } from '@apollo/client';
import { TOKENS_QUERY } from '../graphql/queries';
import { useSubscription } from './subscription';
import { useAuth } from './auth';

const TokensContext = createContext({}) as any;

export const UNLIMITED_SPARK_LIMIT = 'unlimited';

export function TokensProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const { spark_limit } = useSubscription();
  const { data: tokensData } = useQuery(TOKENS_QUERY, {
    skip: !user,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const tokens = tokensData?.tokens;
  const spark_over_limit =
    spark_limit !== UNLIMITED_SPARK_LIMIT && typeof spark_limit === 'number' && tokens?.sparks >= spark_limit;

  return (
    <TokensContext.Provider
      value={{
        spark_tokens: tokens?.sparks || 0,
        spark_limit,
        spark_over_limit,
      }}
    >
      {children}
    </TokensContext.Provider>
  );
}

export function useTokens() {
  return useContext(TokensContext);
}
